import script from "./ArchitectLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./ArchitectLayout.vue?vue&type=script&setup=true&lang=js"

import "./ArchitectLayout.vue?vue&type=style&index=0&id=58958d4e&lang=scss&scoped=true"

import exportComponent from "/home/production/domains/architect.youniversity.be/public_html/architect/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-58958d4e"]])

export default __exports__